// extracted by mini-css-extract-plugin
module.exports = {"home":"home__MseGd","splash":"splash__3BxBh","projectList":"projectList__EGSRk","project":"project__t03K9"};